import AbstractAPI from '@/services/api/AbstractAPI';

export default class TodoApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/todos');
  }

  async list() {
    return this.makeRequest('/', 'get');
  }
}
